import { ChangeDetectorRef, Component } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs';
import { AuthService } from './features/auth';
import { ThemeConfig, ThemeService } from '../shared/service/theme.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent {
  title = 'punto-de-venta';
  config!: ThemeConfig;

  constructor(
    private router: Router,
    private authService:AuthService,
    private route: ActivatedRoute,
    private themeService: ThemeService,
    private _ref: ChangeDetectorRef
  ) {}

  async ngOnInit() {
    // Escuchar eventos de navegación
    this.router.events
    .pipe(filter(event => event instanceof NavigationEnd)) // Filtra para obtener solo NavigationEnd
    .subscribe(() => {
      if (!this.router.url.includes('/login')) {
        this.authService.startTokenRefreshCheck();
        this.authService.setupUserInteractionListeners();
      }
    });
    
    await this.authService.refreshUserData();
    this.applyStoredTheme();

    this.route.paramMap.subscribe(params => {
      const routeThemeName = params.get('name');
      if (routeThemeName) {
        this.loadAndApplyTheme(routeThemeName);
      }
    });
  }
  
  private applyStoredTheme(): void {
    const themeConfig = this.getStoredTheme();
  
    if (themeConfig) {
      this.config = themeConfig;
      this.themeService.applyTheme(themeConfig);
    }
  }
  
  private getStoredTheme(): ThemeConfig | null {
    const localData = localStorage.getItem('themeConfig');
    if (!localData) return null;
  
    try {
      return JSON.parse(localData) as ThemeConfig;
    } catch (error) {
      return null;
    }
  }
  
  private loadAndApplyTheme(name: string): void {
    this.themeService.loadTheme(name).subscribe(theme => {
      this.config = theme;
      this.themeService.applyTheme(theme);
      this._ref.detectChanges();
    });
  }
}
